import { CustomizedTypography } from '@components/Customized';
import { clsx, colorSet } from '@components/Provider';
import { CapaQuotationServiceType } from '@generated/graphql';
import { Box, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import { OptionalServices } from '@routes/RequestServiceType/serviceTypeData';
import React, { useMemo } from 'react';

interface Props {
  selectedOptionalServices: CapaQuotationServiceType[];
}

const optionalServices = [
  CapaQuotationServiceType.ProductDesign,
  CapaQuotationServiceType.MechanicalDesign,
  CapaQuotationServiceType.Prototyping
];

const WorkScopes: React.FC<Props> = ({ selectedOptionalServices }) => {
  const {
    additionalServiceLabel,
    optionalSeriviceItem,
    serviceImage
  } = useStyles();

  const matches = useMediaQuery(useTheme().breakpoints.down('md'));

  const optionalServicesInfo = useMemo(
    () => OptionalServices.filter(({ id }) => optionalServices.includes(id)),
    []
  );

  return (
    <Box
      display="flex"
      flexWrap="nowrap"
      alignItems="center"
      className={additionalServiceLabel}
    >
      {optionalServicesInfo?.map(({ id, serviceName, src }) => (
        <Box
          key={serviceName}
          className={clsx(optionalSeriviceItem, {
            'unselected': !selectedOptionalServices.includes(id)
          })}
        >
          <CustomizedTypography
            variant={matches ? 'body2' : 'body1'}
            color="textPrimary"
            fontWeight="500"
          >
            {serviceName}
          </CustomizedTypography>
          {!matches && (
            <img
              className={serviceImage}
              src={src}
              alt={`${serviceName}_image`}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};
export default WorkScopes;

const useStyles = makeStyles((theme) => ({
  additionalServiceLabel: {
    justifyContent: 'space-around',
    gap: '8px'
  },
  optionalSeriviceItem: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '30%',
      height: 50
    },
    width: 178,
    height: 72,
    border: `2px solid ${colorSet.gray1000}`,
    borderRadius: 12,
    background: colorSet.gray100,
    '&.unselected': {
      border: `1px solid ${colorSet.gray400}`,
      '& p': {
        color: colorSet.gray400
      },
      '& img': {
        opacity: 0.5
      }
    }
  },
  serviceImage: {
    width: 48,
    height: 48,
    borderRadius: 12
  }
}));
